<template>
  <v-container fluid>
    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-col cols="12" style="margin-top: 2%">
        <v-text-field
          :append-icon="'mdi-eye'"
          v-model="Observacion"
          required
          label="Observacion"
          dense
          outlined
        ></v-text-field>

        <v-card color="#1F7087" dark>
          <v-card-title class="text-h5"> Agregar Materiales </v-card-title>
          <v-data-table
            :headers="cabeceras"
            :items="tablaMateriales"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Materiales</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="agregarMaterialALaLista"
                >
                  Agregar Material
                </v-btn>
                <v-dialog v-model="dialog" max-width="500px">
                  <!-- <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Agregar Material
                    </v-btn>
                  </template> -->
                  <!-- <v-card> -->
                  <!-- <v-card-title>
                        <span class="text-h5">Agregar Material</span>
                      </v-card-title> -->

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="editedItem.MaterialSeleccionado"
                            :items="listaMateriales"
                            item-value="idMaterial"
                            item-text="descripcionMaterial"
                            label="Materiales"
                            height="20"
                            return-object
                            @change="cambioMaterial()"
                            no-data-text="No hay coincidencias"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.medida"
                            label="Medida"
                            clearable
                            @keyup.enter="agregarMaterialALaLista"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.cantidad"
                            label="Cantidad"
                            clearable
                            @keyup.enter="agregarMaterialALaLista"
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="agregarMaterialALaLista"
                    >
                      Guardar
                    </v-btn>
                  </v-card-actions>
                  <!-- </v-card> -->
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialConfirmar"
                        >Eliminar Material</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-autocomplete
                v-model="props.item.MaterialSeleccionadoNombre"
                :items="listaMateriales"
                item-value="idMaterial"
                item-text="descripcionMaterial"
                label="Materiales"
                height="20"
                return-object
                @change="cambioMaterial(props.item.MaterialSeleccionadoNombre)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.cantidad`]="props">
              <v-text-field
                v-model="props.item.cantidad"
                label="Cantidad"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <!-- <template v-slot:[`item.medida`]="props">
              {{ props.item.itg_unidad }}
            </template> -->

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterial(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Material</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <v-btn class="mt-5" color="primary" @click="concluirTarea()">
          Concluir Tarea
        </v-btn>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      //idTarea: "",
      dialogDelete: false,
      editedItem: {
        cantidad: 0,
        medida: "",
        MaterialSeleccionado: null,
        MaterialSeleccionadoNombre: null,
        MaterialSeleccionadoId: null,
      },
      Observacion: [],
      listaMateriales: [
        {
          idMaterial: 1,
          descripcionMaterial: "Material 1",
        },
        {
          idMaterial: 2,
          descripcionMaterial: "Material 2",
        },
        {
          idMaterial: 3,
          descripcionMaterial: "Material 3",
        },
        {
          idMaterial: 4,
          descripcionMaterial: "Material 4",
        },
        {
          idMaterial: 5,
          descripcionMaterial: "Material 5",
        },
      ],
      tablaMateriales: [],
      cuadrillas: [],
      idTarea: "",
      cuadrillaSeleccion: "",
      formTitle: "",
      datosTarea: "",
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdCuadrilla: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      cabeceras: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        { text: "Cantidad", value: "cantidad", class: "black white--text" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "black white--text",
        },
      ],
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdCuadrilla === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdCuadrilla === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdCuadrilla > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },

  mounted() {
    const datos = this.$route.params.datos;
    console.log("Los datos recibidos son");
    console.log(datos);
    this.idTarea = this.$route.params.datos.idTarea;
    console.log("El id tarea es");
    console.log(this.idTarea);
    // this.idCuadrilla = datos.idCuadrilla;
    // console.log("El id de la cuadrilla es");
    // console.log(this.idCuadrilla);
    // this.recuperarTareasAsignadasContratista();
  },

  methods: {
    async concluirTarea() {
      var respuesta;

      this.url = this.$store.state.urlBase + "Task/concluirTareaCuadrilla";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMateriales.MaterialSeleccionadoNombre);
      var datos = {
        Materiales: this.tablaMateriales.MaterialSeleccionadoNombre,
        idTarea: this.idTarea,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los datos son");

      console.log(datos);

      this.tablaMateriales.forEach((material) => {
        console.log("El material es:");
        console.log(material.MaterialSeleccionadoNombre);
        console.log(material.cantidad);
      });

      respuesta = await axios
        .post(this.url, config, datos)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      console.log(this.tablaTareasDespachadasCuadrilla);
    },

    editItem(item) {
      this.editedIndex = this.tablaMateriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    eliminarMaterial(item) {
      this.editedIndex = this.tablaMateriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    eliminarMaterialConfirmar() {
      this.tablaMateriales.splice(this.editedIndex, 1);
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cambioMaterial(repuesto) {
      var index = this.tablaMateriales.findIndex(
        (e) => e.repuestoSeleccionadoNombre === repuesto
      ); //find the index of the product you want to update
      var repuestosDisponibles = this.tablaMateriales.find(
        (e) => e.repuestoSeleccionadoNombre === repuesto
      ); // find the product price
      if (index !== -1 && repuestosDisponibles) {
        //this.tablaMateriales[index].cantidad = repuesto.itg_unidad; // update list if you found the product information and the index
        this.tablaMateriales[index].materialSeleccionadoId =
          repuesto.idMaterial;
      }
    },

    agregarMaterialALaLista() {
      console.log("Ingreso en agregar a la lista");
      if (this.editedIndex > -1) {
        Object.assign(this.tablaMateriales[this.editedIndex], this.editedItem);
      } else {
        console.log("El ultimo registro es: ");
        console.log(this.tablaMateriales[this.tablaMateriales.length - 1]);
        if (this.tablaMateriales.length == 0) {
          this.tablaMateriales.push(this.editedItem);
        } else {
          if (
            this.tablaMateriales[this.tablaMateriales.length - 1].cantidad != 0
          ) {
            this.tablaMateriales.push(this.editedItem);
          }
        }
      }
      console.log("Estoy hay en la tabla respuesto: ");
      console.log(this.tablaMateriales);

      //console.log(this.tablaMateriales[0].cantidad);
      //console.log(this.tablaMateriales[0].MaterialSeleccionadoNombre);
      this.close();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    abrirModalTareaCuadrilla(datos) {
      this.datosTarea = datos;
      this.colorDialogTitle = "green";
      //this.tipoModal_IdCuadrilla = tipo;
      //   if (this.tipoModal_IdCuadrilla != 0) {
      //     this.getCuadrillabyID(tipo);
      //   } else {
      //     this.empleados = [];
      //     this.contratistaSeleccion = [];
      //   }
      this.formDialog = "Ingrese los datos para concluir la tarea";
      console.log("Los datos de la tarea son");
      console.log(this.datosTarea);
      console.log(this.datosTarea.identificador);
      this.dialog = true;
    },
  },
};
</script>

<style></style>
